/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCollateralType } from './ClaimCollateralType';
import {
    ClaimCollateralTypeFromJSON,
    ClaimCollateralTypeFromJSONTyped,
    ClaimCollateralTypeToJSON,
    ClaimCollateralTypeToJSONTyped,
} from './ClaimCollateralType';

/**
 * 
 * @export
 * @interface ClaimCollateralResponse
 */
export interface ClaimCollateralResponse {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    id: string;
    /**
     * 
     * @type {ClaimCollateralType}
     * @memberof ClaimCollateralResponse
     */
    type: ClaimCollateralType;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    holdingId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralResponse
     */
    details: string | null;
}



/**
 * Check if a given object implements the ClaimCollateralResponse interface.
 */
export function instanceOfClaimCollateralResponse(value: object): value is ClaimCollateralResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('holdingId' in value) || value['holdingId'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function ClaimCollateralResponseFromJSON(json: any): ClaimCollateralResponse {
    return ClaimCollateralResponseFromJSONTyped(json, false);
}

export function ClaimCollateralResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCollateralResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ClaimCollateralTypeFromJSON(json['type']),
        'holdingId': json['holdingId'],
        'details': json['details'],
    };
}

export function ClaimCollateralResponseToJSON(json: any): ClaimCollateralResponse {
    return ClaimCollateralResponseToJSONTyped(json, false);
}

export function ClaimCollateralResponseToJSONTyped(value?: ClaimCollateralResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ClaimCollateralTypeToJSON(value['type']),
        'holdingId': value['holdingId'],
        'details': value['details'],
    };
}

